import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';

import { ProductTypes } from 'common/src/modules/products/product-types';


@Component({
  selector: 'rnpl-data-import-product-type-modal',
  templateUrl: './data-import-product-type-modal.component.html'
})
export class DataImportProductTypeModalComponent {

  public form: FormGroup;
  public productTypes = ProductTypes;

  constructor(
    private readonly fb: FormBuilder,
    public readonly dialogRef: MatDialogRef<DataImportProductTypeModalComponent>,
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });

    this.initForm();
  }

  private initForm(): void {
    this.form = this.fb.group({
      productType: [null, [Validators.required]],
      glProductTypeId: [null],
      // glProductTypeId: [null, [Validators.required]],
    });
  }

  public productTypeChanged(): void {
    this.glProductTypeIdControl.reset();
  }

  public submit(): void {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();

    if (this.form.invalid) { return; }

    this.dialogRef.close(this.form.getRawValue());
  }

  get productTypeControl(): FormControl { return this.form.get('productType') as FormControl; }
  get glProductTypeIdControl(): FormControl { return this.form.get('glProductTypeId') as FormControl; }

}

